//
//
//
//

import DeviceAndPlaylistLayout from "../components-v2/DeviceAndPlaylistLayout.vue";
export default {
  components: {
    DeviceAndPlaylistLayout,
  },
};
